export default "__VITE_ASSET__B$ZF$BVu__"